import { axiosInstance } from "./axios";
import useCustomMutation from "hooks/useCustomMutation";
import useCustomQuery from "hooks/useCustomQuery";
import { IIssue } from "dto/Helpdesk/IIssue";

const queryKeys = {
  getIssueEncryptionKeys: () => "helpdeskService.getIssueEncryptionKeys",
};

export interface Attachment {
  KeyId?: string;
  Order: number;
  Uri: string;
}

export interface ICreateIssue {
  Attachments: Attachment[];
  Title: string | null;
  TagIds?: string[];
  Content: string;

  PublicKey?: string;
  PrivateKey?: string;
}

const createIssue = (payload: ICreateIssue): Promise<{ data: IIssue }> => {
  return axiosInstance.post("/issue", payload);
};

const useCreateIssue = () => {
  return useCustomMutation(createIssue);
};

export interface IKeysResponse {
  Keys: IUserKey[];
}

export interface IUserKey {
  UserId: string;
  PublicKey: string;
}

const getIssueEncryptionKeys = (): Promise<{ data: IKeysResponse }> => {
  return axiosInstance.get("issues/keys");
};

const useGetIssueEncryptionKeys = () => {
  return useCustomQuery(queryKeys.getIssueEncryptionKeys(), () =>
    getIssueEncryptionKeys()
  );
};

export default {
  useCreateIssue,
  useGetIssueEncryptionKeys,
};
